import { api } from "../..";
import { ApiConfig } from "../../ApiConfig";

const baseURL = ApiConfig.baseApi;

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const buildUrl = (path = "") => `${baseURL}${ApiConfig.plan}${path}`;

const planService = {
  list: async (country) => {
    let url = buildUrl();
    if (country) {
      url += `?country=${encodeURIComponent(String(country).trim())}`;
    }
    return api.get(url, null, getHeaders());
  },

  listByCountry: async (country) => {
    const encodedCountry = encodeURIComponent(String(country || "").trim());
    const url = buildUrl(`/country/${encodedCountry}`);
    return api.get(url, null, getHeaders());
  },

  getById: async (id) => {
    const url = buildUrl(`/${id}`);
    return api.get(url, null, getHeaders());
  },

  create: async (payload) => {
    const url = buildUrl();
    return api.post(url, payload, getHeaders());
  },

  update: async (id, payload) => {
    const url = buildUrl(`/${id}`);
    return api.put(url, payload, getHeaders());
  },

  delete: async (id) => {
    const url = buildUrl(`/${id}`);
    return api.delete(url, undefined, getHeaders());
  },

  // Assign/update a country price. Synchronously creates the Dodo product (first
  // country) + Localized Price. Response: top-level success = Mongo write;
  // data.syncResult = the Dodo-side call (success + reason). A syncResult failure
  // means "saved locally, not live on checkout" — surface it distinctly.
  assignPricing: async (id, payload) => {
    const url = buildUrl(`/${id}/pricing`);
    return api.post(url, payload, getHeaders());
  },

  // Soft-delete a country price (entry stays with isActive:false).
  removePricing: async (id, country) => {
    const url = buildUrl(`/${id}/pricing/${encodeURIComponent(country)}`);
    return api.delete(url, undefined, getHeaders());
  },
};

export default planService;
